import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'

import { Form, Button, Card, DatePicker } from 'antd'
import { LoadingOutlined , DownloadOutlined } from '@ant-design/icons'

import SupplierOrderActions from '../../redux/supplierOrders/actions'

const { RangePicker } = DatePicker
const { fetchDriverShippingInfos } = SupplierOrderActions

class ExportDriverInfo extends Component {
    constructor (props) {
        super(props)

        this.formRef = createRef()
    }

    handleSubmit = (e) => {
        const { fetchDriverShippingInfos } = this.props
        e.preventDefault()

        this.formRef.current.validateFields().then(fieldValue => {
            let startDate = null
            let endDate = null
            if (fieldValue['range_picker']) {
                startDate = fieldValue['range_picker'][0].format('YYYY-MM-DD')
                endDate = fieldValue['range_picker'][1].format('YYYY-MM-DD')
            }

            const values = {
                start_date: startDate,
                end_date: endDate
            }

            fetchDriverShippingInfos(values)
        })
    }

    render () {
        const { supplierOrders, i18n } = this.props
        const loading = supplierOrders.get('shippingCostLoading')
        const formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        }
        const buttonItemLayout = {
            wrapperCol: { span: 14, offset: 4 }
        }

        return (
            <Card
                title={i18n.t('suppliers:shippingCost.driverInfo')}
                style={{ margin: '20px 0' }}
            >
                <Form layout="inline"
                    labelAlign="left"
                    ref={this.formRef}
                    hideRequiredMark>
                    <Form.Item label={i18n.t('suppliers:shippingCost.searchDate')}
                        name='range_picker'
                        rules={[{
                            required: true,
                            message: i18n.t('suppliers:shippingCost.pleaseInputDate')
                        }]}
                        {...formItemLayout}>
                            <RangePicker />
                    </Form.Item>
                    <Form.Item {...buttonItemLayout}>
                        <Button
                            icon={loading ? <LoadingOutlined /> : <DownloadOutlined />}
                            onClick={this.handleSubmit}
                            htmlType="submit">
                            {i18n.t('suppliers:shippingCost.download')}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        )
    }
}

const mapStateToProps = state => ({
    supplierOrders: state.get('supplierOrders')
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchDriverShippingInfos
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(
    withTranslation('suppliers')(ExportDriverInfo))
